import React from "react"
import PropTypes from "prop-types"
import classnames from "classnames"
import { Link } from "gatsby"

import("../styles/ctaButton.scss")

const CTAButton = props => {
  let link =
    props.external === "true" ? (
      <a
        className={classnames({
          ctaButton: true,
          blueButton: props.color === "blue",
          whiteButton: props.color === "white",
        })}
        href={props.href}
      >
        {props.children}
      </a>
    ) : (
      <Link
        className={classnames({
          ctaButton: true,
          blueButton: props.color === "blue",
          whiteButton: props.color === "white",
        })}
        to={props.href}
      >
        {props.children}
      </Link>
    )
  return link
}

CTAButton.propTypes = {
  children: PropTypes.node.isRequired,
  color: PropTypes.oneOf(["blue", "white"]),
  href: PropTypes.string,
  external: PropTypes.bool,
}

CTAButton.defaultProps = {
  children: null,
  color: "blue",
  href: "#",
  external: false,
}

export default CTAButton
